import { dateMask, hoursMask } from '../../../../../helpers/masks';
import {
	InputLabel, SelectLabel, CheckboxLabel, SelectAutoComplete
} from '../../../../../common/components/form/fields';
import { FORM_RULES } from "../../../../../helpers/validations";

const inputStyle = { fontSize: "1.6rem", padding: 20, borderRadius: ".5rem" };
const style = { textAlign: "left", fontSize: "1.6rem", paddingBottom: 10 };
const selectStyle = { textAlign: "left", fontSize: "1.6rem", paddingBottom: 20 };

export default (getCities, optionsCategories) => [
	{
		component: InputLabel,
		type: "text",
		name: "person_name",
        placeholder:"Nome da pessoa",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "name",
        placeholder:"Comentário",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "birthday",
        placeholder:"Data de nascimento",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
        inputStyle,
        ...dateMask
	},
	{
		component: InputLabel,
		type: "text",
		name: "hour",
        placeholder:"Hora",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
        inputStyle,
        ...hoursMask
	},
	{
		component: SelectAutoComplete,
		type: "text",
		name: 'city',
		handleSearchInput: getCities,
        placeholder:"Selecione a cidade",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style: selectStyle,
    },
	{
		component: SelectLabel,
		type: "text",
		name: 'category',
        placeholder:"Selecione a categoria",
		cols: "12 12 12 12",
		options: optionsCategories(),
		style: selectStyle,
    },
    {
		component: CheckboxLabel,
		type: "text",
		name: "daylight_savings",
        label: "Horário de verão",
		cols: "12 12 12 12",
		values: false,
		option: {
			label: 'Horário de verão',
			value: false
		},
		style,
		labelStyle: { fontSize: "1.8rem" }
	},
];
